import type { TodayOffer } from "./types";

export function placesTaken(offer: TodayOffer): number {
  const places = offer.occupiedPlaces;
  return places.kind === "split" ? places.paid + places.awaitingConfirmation : places.occupied;
}

/** Never negative: a slot can be oversold by a race the portal did not run,
 *  and „zbývá −1 místo" is a bug report, not a number a partner can act on. */
export function placesLeft(offer: TodayOffer): number {
  return Math.max(0, offer.capacity - placesTaken(offer));
}

/** The end the API resolved can be a per-kind default that lapsed when the slot
 *  started — the termín is listed precisely because a lapsed default decided
 *  nothing and the class can still take a walk-in. Saying „prodej do 08:00" at
 *  ten o'clock would state the sale is over on the one row that proves it is
 *  not, so a passed end is not a time worth printing. */
export function saleEndStillAhead(offer: TodayOffer, now: Date = new Date()): Date | null {
  if (offer.saleEndTime == null) return null;
  return offer.saleEndTime.getTime() > now.getTime() ? offer.saleEndTime : null;
}
